import { defineStore } from "pinia";

export const useDelegateStore = defineStore('delegate', {
    state: () => ({
        delegate: {},
        delegates: [],
    }),
    actions: {
        setDelegate(delegate) {
            this.delegate = delegate
        },
        setDelegates(delegates) {
            this.delegates = delegates
        },
        addDelegate(delegate) {
            this.delegates.unshift(delegate)
        },
        updateDelegate(delegate) {
            let index = this.delegates.findIndex(cl => cl.id === delegate.id)
            this.delegates.splice(index, 1, delegate)
        },
        deleteDelegate(delegate) {
            let index = this.delegates.findIndex(cl => cl.id === delegate.id)
            this.delegates.splice(index, 1)
        },
    },
});